// extracted by mini-css-extract-plugin
module.exports = {"componentsOpenNativeList":"styles_componentsOpenNativeList__E86Yi","notSupportInfo":"styles_notSupportInfo__1n6Q3","opText":"styles_opText__1zPei"};